/* eslint-disable */

function load_panel_logos() {

  var logos = '';

  if(jQuery('.gform_wrapper .gform_body .gform_page').length) {
    jQuery('.gform_wrapper .gform_body .gform_page .trust-logos').each(function(){
      var $this = jQuery(this);
      logos = $this.length ? jQuery($this).html() : '';
    });
  }
  if(jQuery('.gform_wrapper .gform_body ul.gform_fields .collapsible-sections-collapsible-body').length) {
    jQuery('ul.gform_fields .collapsible-sections-collapsible-body .trust-logos').each(function(){
      var $this = jQuery(this);
      logos = $this.length ? jQuery($this).html() : '';
    });
  }

  return logos;

}

function load_panel_image() {

  if (jQuery(window).width() > 960) {

    if(jQuery('.gform_wrapper .gform_body .gform_page').length) {
      jQuery('.gform_wrapper .gform_body .gform_page').each(function () {

        var $this = jQuery(this);

        jQuery($this).append('<div class="page_background"><div class="trust-logo-wrappers"><span>Book with Confidence</span>' + load_panel_logos() + '</div></div>');

        // Write a check for this to make sure its a url / img later
        var image = jQuery($this).find('.background-images').text();
        jQuery($this).find('.page_background').css({'background-image': 'url(' + image + ')'});

      });
    }

    if(jQuery('.gform_wrapper .gform_body ul.gform_fields .collapsible-sections-collapsible-body').length) {
      jQuery('.gform_body').append('<div class="page_background"><div class="trust-logo-wrappers"><span>Book with Confidence</span>' + load_panel_logos() + '</div></div>');
      // jQuery('.gform_wrapper .gform_body ul.gform_fields .collapsible-sections-collapsible-body').each(function () {
      //
      //   var $this = jQuery(this);
      //
      //   jQuery($this).append('<div class="page_background"><div class="trust-logo-wrappers"><span>Book with Confidence</span>' + load_panel_logos() + '</div></div>');
      //
      //   // Write a check for this to make sure its a url / img later
      //   var image = jQuery($this).find('.background-images').text();
      //   jQuery($this).find('.page_background').css({'background-image': 'url(' + image + ')'});
      //
      // });
    }

  }

}

function scroll_navigation() {

  // Turning this off for now, its too annoying.

  var next = jQuery('.gform_page:visible .gform_next_button');
  var prev = jQuery('.gform_page:visible .gform_previous_button');

  jQuery(window).bind('mousewheel', function (event) {
      if (event.originalEvent.wheelDelta >= 0) {
          jQuery(prev).trigger('click');
      } else {
          jQuery(next).trigger('click');
      }
      return;
  });

}

function middle_screen_next(current_page,form_id) {

    var target = jQuery('#gform_page_' + form_id + '_' + current_page + ' .middle_screen');

    if(target.length) {
      setTimeout(function() {
        if(jQuery('#gform_page_' + form_id + '_' + current_page + ' .gform_next_button').length) {
          jQuery('#gform_page_' + form_id + '_' + current_page + ' .gform_next_button').trigger('click');
        }
      }, 2500);

      jQuery('#gform_page_' + form_id + '_' + current_page + ' .gform_page_footer').css({'opacity': 0});

    }

}


function double_back_button(current_page,form_id) {

  var target = jQuery('#gform_page_' + form_id + '_' + current_page + ' .middle_screen');

  if(!target.length) {

    var page = parseInt(current_page) - parseInt(2);
    jQuery('#gform_page_' + form_id + '_' + current_page + ' .gform_previous_button').click(function(event){
      event.preventDefault();
      jQuery('#gform_target_page_number_' + form_id).val(page);
      jQuery('#gform_' + form_id).trigger('submit',[true]);
    });

    console.log(page);

  }

}


function early_submit_button(form_id) {

  if(jQuery('.early-submit').length) {
    jQuery('.early-submit').click(function (event) {
      event.preventDefault();
      var lastPage = jQuery('#gform_' + form_id + ' .gform_page').length + 1;
      jQuery('#gform_target_page_number_' + form_id).val(lastPage);
      jQuery('#gform_' + form_id).trigger('submit',[true]);
    });
  }

}

/* GF hard codes ID's */
// function load_wishlist() {
//   if(jQuery('#wishlist').length) {
//     var favs = jQuery('#wishlist').text();
//     jQuery('#input_1_76').val(favs)
//   }
// }


jQuery(document).ready(function(){
  if(jQuery('body').hasClass('page-template-template-planner')) {
    load_panel_image();
  }
  if(jQuery('.gform_page select').length && typeof select2 == 'function') {
    jQuery('.gform_page select').select2();
  }
  //load_wishlist();
})
jQuery(document).on('gform_page_loaded', function(event, form_id, current_page) {

  if(jQuery('body').hasClass('page-template-template-planner')) {
    load_panel_image();
  }

  middle_screen_next(current_page,form_id);
  double_back_button(current_page,form_id);
  early_submit_button(form_id);

  if(jQuery('.gform_page select').length && typeof select2 == 'function') {
    jQuery('.gform_page select').select2();
  }

});

/* eslint-disable */

function check_if_date_selected() {

  var button = jQuery('.gform_next_button');
  var inputField = jQuery('#drpf');

  button.attr('disabled', true); // disable next button

  // check if input had a value, if it does enable the button
  if(inputField.val() !== '') {
    button.attr('disabled', false);
  }


}



function month_range_picker() {

  if(jQuery('.cedar-month-picker').length) { 
    // I know this parent of parent of parent is not ideal but its so the input field can be as dynamic as possible, not locked to a class or type
    jQuery('.cedar-month-picker').parent().parent().find('input').multiMonthPicker();
    // jQuery('.cedar-month-picker').parent().parent().find('input').trigger('click');
    // jQuery('.cedar-month-picker').parent().parent().find('input').parent().hide();
    // jQuery('.cedar-month-picker').parent().parent().find('input').parent().parent().find('label').hide();
  }

}

jQuery(document).ready(function(){
  month_range_picker();
});


jQuery(window).on('load', function(){

  var target = jQuery('#drpf');

  if(target.length && target.is(':visible')) {

    var inputField = jQuery('input[id="drpf"]').val().split(" - ");
    if(typeof(inputField[0]) != "undefined" && inputField[0] !== null) { var startD = inputField[0]; } else { ''; }
    if(typeof(inputField[1]) != "undefined" && inputField[1] !== null) { var endD = inputField[1]; } else { ''; }

    target.data("daterangepicker").show(); // auto open
    
    // disabling closing by clicking away
    target.on('outsideClick.daterangepicker', function(ev, picker) {
      target.data("daterangepicker").show();
    });

    jQuery('.daterangepicker .applyBtn').click(function(){
      jQuery('.daterangepicker').addClass('loading');
      setTimeout(function(){ check_if_date_selected(); }, 1000);
      setTimeout(function(){ jQuery('.daterangepicker').removeClass('loading'); }, 2000);
      
    });

    check_if_date_selected(); // on load disable next button

    // ensure when going back the date field has to reload
    jQuery('.gform_previous_button').click(function(startD,endD){
      target.data("daterangepicker").show();
    });

  } 

});


/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
function cedar_update_all_destinations(){

    if(jQuery('#gform_page_15_1 #field_15_90').length) {

        var checkedVals = jQuery('#gform_page_15_1 input[type="checkbox"]:checkbox:checked').map(function() {
            return this.value;
        }).get();
        jQuery('#gform_page_15_1 #field_15_90 input').val(checkedVals.join(","));
        console.log(checkedVals.join(","));
                
    }
    
}

jQuery(document).ready(function(){

    // check if on first 
    if(jQuery('#gform_page_15_1').length) {

        jQuery('#gform_page_15_1 input[type="checkbox"]').change(function(){
           cedar_update_all_destinations(); 
        });

        
    }

});


// WEBPACK FOOTER //
// ./scripts/routes/planner.js